import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ModalModule } from "ngx-modal";
import { LayoutModule } from "../shared/layout.module";
import { SharedModule } from "../shared/shared.module";
import { IndexModule } from "./index/index.module";
import { LoginComponent } from "./login/login.component";

/* components */
import { PagesComponent } from "./pages.component";
import { routing } from "./pages.routing";
// Import ng-circle-progress
import { NgCircleProgressModule } from 'ng-circle-progress';
import { DonacionesComponent } from './donaciones/donaciones.component';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    FormsModule,
    SharedModule,
    HttpClientModule,
    ModalModule,
    routing,
    IndexModule,
    // Specify ng-circle-progress as an import
    NgCircleProgressModule.forRoot({})
  ],
  declarations: [    
    LoginComponent,
    PagesComponent,
    DonacionesComponent    
  ],
  exports: []
})
export class PagesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts